import { render, staticRenderFns } from "./settings-menu.vue?vue&type=template&id=b968dd42&"
import script from "./settings-menu.vue?vue&type=script&lang=ts&"
export * from "./settings-menu.vue?vue&type=script&lang=ts&"
import style0 from "./settings-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports